import { render, staticRenderFns } from "./WorkScheduleSkeleton.vue?vue&type=template&id=1a5b58b8&"
import script from "./WorkScheduleSkeleton.vue?vue&type=script&lang=ts&setup=true&"
export * from "./WorkScheduleSkeleton.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./WorkScheduleSkeleton.vue?vue&type=style&index=0&id=1a5b58b8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5b58b8')) {
      api.createRecord('1a5b58b8', component.options)
    } else {
      api.reload('1a5b58b8', component.options)
    }
    module.hot.accept("./WorkScheduleSkeleton.vue?vue&type=template&id=1a5b58b8&", function () {
      api.rerender('1a5b58b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/WorkSchedule/components/WorkScheduleSkeleton.vue"
export default component.exports